import {
  createReducer,
  defaultListInitialState,
  createRequestReducer
} from 'utils';
import { GET_SITEMAP } from '../constants';

const sitemapInitialState = defaultListInitialState();
sitemapInitialState.sitemap = {};

const sitemap = createReducer(sitemapInitialState, {
  [GET_SITEMAP]: (state, action) => createRequestReducer(state, action, {
    SEND: (state, action) => Object.assign({}, state, {
      isFetching: true,
      error: null
    }),

    SUCCESS: (state, action) =>
      Object.assign({}, state, {
        isFetching: false,
        error: null,
        sitemap: action.response.reduce((countries, url) => {
          const countryName = url.searchCity ? url.searchCity.country.nameEn : 'Worldwide';

          if (!(countryName in countries)) {
            countries[countryName] = [];
          }

          countries[countryName].push(url);

          return countries;
        }, {})
      }),

    FAIL: (state, action) =>
      Object.assign({}, state, {
        isFetching: false,
        error: action.error
      })
  })
});

export default sitemap;



// WEBPACK FOOTER //
// ./src/reducers/sitemap.js